import React, {useCallback, useMemo, useState} from 'react';
import {isDeviceSmall} from 'shared/helpers/DeviceSize';
import {MoreInfoModal} from 'shared/components/MoreInfo/MoreInfoModal';
import {ButtonWithPopover} from './ButtonWithPopover';
import styled, {CSSProperties} from 'styled-components';
import {MoreInfoScope} from 'shared/components/MoreInfo/helpers/useMoreInfo';

interface MoreInfoProps {
    hoverText?: number | string | JSX.Element;
    info?: number | string | JSX.Element;
    className?: string;
    visible?: boolean;
    scope?: MoreInfoScope;
    dynamicposition?: boolean;
    disabled?: boolean;
    styleOverride?: CSSProperties;
    editbuttonVisible?: boolean;
    dialogClassName?: string;
    iconColor?: string;
}

export const MoreInfo = ({
    hoverText,
    info,
    className,
    visible = false,
    editbuttonVisible = true,
    scope,
    dynamicposition = false,
    disabled = false,
    styleOverride,
    dialogClassName,
    iconColor,
}: MoreInfoProps) => {
    const isSmallDevice = isDeviceSmall();
    const [show, setShow] = useState(visible);

    const handleClose = useCallback(() => {
        setShow(false);
    }, []);

    const handleShow = useCallback(
        (event: React.MouseEvent) => {
            event.preventDefault();
            event.stopPropagation();

            if (info) {
                setShow(true);
            }
        },
        [info]
    );

    const tooltipText = useMemo(() => {
        return typeof hoverText !== 'undefined' ? hoverText : 'More Info';
    }, [hoverText]);

    const htmlClassName = useMemo(() => {
        let htmlClassName = 'info-modal';

        if (isSmallDevice) htmlClassName += ' mobile';

        return htmlClassName;
    }, [isSmallDevice]);

    return (
        <div
            className={`${className ? className : ''} more-info`}
            style={{
                position: dynamicposition === true ? 'relative' : 'absolute',
                ...(styleOverride || {}),
            }}>
            {show ? (
                <MoreInfoModal
                    handleClose={handleClose}
                    tooltipText={tooltipText}
                    htmlClassName={htmlClassName}
                    dialogClassName={dialogClassName}
                    editbuttonVisible={editbuttonVisible}
                    info={info}
                    scope={scope}
                />
            ) : null}

            <ButtonWithPopover
                handleShow={handleShow}
                dynamicposition={dynamicposition}
                disabled={disabled}
                tooltipText={tooltipText}
                iconColor={iconColor}
            />
        </div>
    );
};

export const MoreInfoStatic = styled(MoreInfo)`
    position: initial !important;

    > button {
        margin: 0 0 0 10px !important;
        width: 20px !important;
    }
`;
